<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height color="grey">
        <password title="Zmiana hasła" @change="reset"></password>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authResource } from '@witkac/kartamiejska-resources';

import Password from '@/components/material/Password';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Widok resetu hasła
// @group Account
export default {
  components: {
    Password
  },
  mixins: [notificationsMixin],
  methods: {
    // @vuese
    // Reset hasła
    reset(password) {
      authResource
        .setPassword(this.$route.params.token, password)
        .then(() => {
          this.notifySuccess('Twoje hasło zostało zresetowane.');
          this.$router.push({ name: 'login' });
        })
        .catch(err => this.notifyError('Nie udało się zresetować hasła.', [err.graphQLErrors[0].message]));
    }
  }
};
</script>